import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import Logo from '../Logo';
import './Hero.css';

export function Hero() {
    const { t, language } = useLanguage();
    const isRtl = language === 'ar';

    return (
        <section className="hero-section" dir={isRtl ? 'rtl' : 'ltr'}>
            <div className="hero-container">
                
                {/* Logo wrapper ensures the animation never distorts */}
                <Logo className="hero-logo-custom" />
                
                <h1 className="hero-heading">
                    {t('hero.title') || (isRtl ? 'نبني أحلامك' : 'Building Your Dreams')}
                </h1>
                
                <p className="hero-subheading">
                    {t('hero.subtitle') || (isRtl ? 'شركة مقاولات رائدة تقدم التميز في كل مشروع.' : 'A leading construction company delivering excellence in every project.')}
                </p>
                
                <div className="hero-action-buttons">
                    <Link to="/contact" className="hero-btn hero-btn-red">
                        {t('hero.cta1') || (isRtl ? 'تواصل معنا' : 'Contact Us')}
                    </Link>
                    <Link to="/portfolio" className="hero-btn hero-btn-outline">
                        {t('hero.cta2') || (isRtl ? 'شاهد مشاريعنا' : 'View Projects')}
                    </Link>
                </div>
                
            </div>
        </section>
    );
}
